<template>
  <v-card class="templateCard elevation-5">
    <v-card-text>
      <v-layout justify-space-between align-start wrap>
        <CardHeader />

        <v-flex xs12>
          <v-row class="mx-0 mt-1 mb-4">
            <v-col class="pt-0">
              <v-layout align-center mb-5 class="successTitle">
                <div>
                  <v-icon
                    x-large
                    color="error"
                    v-if="this.status === 'error'"
                    >{{ failureIcon }}</v-icon
                  >
                  <v-icon x-large color="success" v-else>{{
                    successIcon
                  }}</v-icon>
                </div>
                <v-flex mx-2 class="title" mt-1>
                  <label>
                    {{ $translate(`static_${status}_title`) }}
                  </label>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="successInnerTitle mb-3">
                  {{ $translate(`static_${status}_body`) }}
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import CardHeader from '../Shared/components/CardHeader.vue';
import { mdiCheckCircleOutline, mdiAlertCircleOutline } from '@mdi/js'; //named import for Alert Icon.

export default {
  data() {
    return {
      failureIcon: mdiAlertCircleOutline,
      successIcon: mdiCheckCircleOutline,
      status: this.$route.params.paymentStatus,
    };
  },
  components: {
    CardHeader,
  },
};
</script>
